import React from "react";
import "antd/dist/antd.css";
import { Form, Input, Collapse } from "antd";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import { formatNumber } from "../../Util/util";
import { getRetrainCostForRole, getWagePlusBenefitsForRole } from "../Logics/retrainCalculations";
import { getLabel, getHelp, getValidateStatus } from "../../Util/util";
import { getIcon } from "../../Util/iconUtil";
import { hourlyBenefitTooltip, retrainingHoursTooltip, otherRetrainCosts } from "../../Util/writing";

const { Panel } = Collapse;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 11 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

const inputFormDivStyle = {
  border: "1px solid #ebedf0",
  borderRadius: "2px",
  marginTop: "5px",
  marginLeft: "20px",
  marginRight: "20px",
  marginBottom: "5px",
  backgroundColor: "white",
  padding: "10px",
};

const RetrainingCosts = (props) => {
  const updateRoleAttr = (e) => {
    const inputFieldId = e.currentTarget.id;
    const [role, attr] = inputFieldId.split("-");
    const value = e.currentTarget.value;
    props.setRetrainCostForRoleAttr({ role, attr, value });
  };

  const updateCommonAttr = (e) => {
    const inputField = e.currentTarget.id;
    const value = e.currentTarget.value;
    props.setRetrainCommonAttr({ [inputField]: value });
  };

  /**
   * Makes the HTML input fields for one role given key and description.
   */
  const makeRoleInputFields = (role, name, plural, required) => {
    return (
      <React.Fragment key={role + "-input-fields"}>
        <Collapse expandIcon={() => getIcon(role, "role")}>
          <Panel
            header={name}
            key={role + "-input-fields"}
            extra={formatNumber(getRetrainCostForRole(role)) + " " + props.currency}
          >
            <Form.Item
              label={"Number of " + plural}
              required={required}
              validateStatus={getValidateStatus(
                props.retrainCostDetails.roles.find((obj) => obj.role === role)["number"]
              )}
              help={getHelp(props.retrainCostDetails.roles.find((obj) => obj.role === role)["number"])}
            >
              <Input
                addonAfter="Persons"
                placeholder=""
                id={role + "-number"}
                onChange={updateRoleAttr}
                className="numberInput"
                value={props.retrainCostDetails.roles.find((obj) => obj.role === role)["number"]}
              />
            </Form.Item>

            <Form.Item
              label={"Hourly Wage of " + name}
              required={required}
              validateStatus={getValidateStatus(
                props.retrainCostDetails.roles.find((obj) => obj.role === role)["wage"]
              )}
              help={getHelp(props.retrainCostDetails.roles.find((obj) => obj.role === role)["wage"])}
            >
              <Input
                addonAfter={props.currency}
                placeholder=""
                id={role + "-wage"}
                onChange={updateRoleAttr}
                className="numberInput"
                value={props.retrainCostDetails.roles.find((obj) => obj.role === role)["wage"]}
              />
            </Form.Item>

            <Form.Item
              label={getLabel("Hourly Benefits Amount", hourlyBenefitTooltip)}
              required={required}
              validateStatus={getValidateStatus(
                props.retrainCostDetails.roles.find((obj) => obj.role === role)["benefit"]
              )}
              help={getHelp(props.retrainCostDetails.roles.find((obj) => obj.role === role)["benefit"])}
            >
              <Input
                addonAfter={props.currency}
                placeholder=""
                id={role + "-benefit"}
                onChange={updateRoleAttr}
                className="numberInput"
                value={props.retrainCostDetails.roles.find((obj) => obj.role === role)["benefit"]}
              />
            </Form.Item>

            <Form.Item label="Hourly Wage Plus Benefits" help="">
              <Input
                addonAfter={props.currency}
                placeholder=""
                disabled
                id={role + "-wageplusben"}
                value={formatNumber(getWagePlusBenefitsForRole(role))}
              />
            </Form.Item>

            <Form.Item
              label={getLabel("Retraining Hours", retrainingHoursTooltip)}
              required={required}
              validateStatus={getValidateStatus(
                props.retrainCostDetails.roles.find((obj) => obj.role === role)["hours"]
              )}
              help={getHelp(props.retrainCostDetails.roles.find((obj) => obj.role === role)["hours"])}
            >
              <Input
                addonAfter="Hours"
                placeholder=""
                id={role + "-hours"}
                onChange={updateRoleAttr}
                className="numberInput"
                value={props.retrainCostDetails.roles.find((obj) => obj.role === role)["hours"]}
              />
            </Form.Item>
          </Panel>
        </Collapse>
      </React.Fragment>
    );
  };

  /**
   * Using the list of roles, return HTML input fields for all roles.
   */
  const makeAllInputFieldsForRoles = () => {
    return props.roleList.map((item) => makeRoleInputFields(item.role, item.name, item.plural, item.required));
  };

  // const makeRoleOutputFields = (role, name, plural) => {
  //   return (
  //     <Form.Item label={`Total ${name} Retraining Costs`} help="" key={role + "-calculated-fields"}>
  //       <Input
  //         addonAfter={props.currency}
  //         placeholder=""
  //         id={role + "-totalcost"}
  //         disabled
  //         value={formatNumber(getRetrainCostForRole(role))}
  //       />
  //     </Form.Item>
  //   );
  // };

  // const makeAllOutputFieldsForRoles = () => {
  //   return props.roleList.map((item) => makeRoleOutputFields(item.role, item.name, item.plural));
  // };

  return (
    <React.Fragment>
      {/* Input */}
      <div style={inputFormDivStyle}>
        <Form {...formItemLayout}>
          {makeAllInputFieldsForRoles()}
          <Collapse expandIcon={() => getIcon(props.retrainCostDetails, "retrainOther")}>
            <Panel
              header="Other"
              key={"other"}
              extra={formatNumber(props.retrainCostDetails.othercosts) + " " + props.currency}
              id="retrainingOtherPanel"
            >
              <Form.Item
                label={getLabel("Other Costs", otherRetrainCosts)}
                validateStatus={getValidateStatus(props.retrainCostDetails.othercosts)}
                help={getHelp(props.retrainCostDetails.othercosts)}
              >
                <Input
                  addonAfter={props.currency}
                  placeholder=""
                  id="othercosts"
                  onChange={updateCommonAttr}
                  value={props.retrainCostDetails.othercosts}
                />
              </Form.Item>
            </Panel>
          </Collapse>
        </Form>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    currency: state.currency.currency,
    totalRetrainingCost: state.costs.totalRetrainingCost,
    retrainCostDetails: state.costs.retrainCostDetails,
    roleList: state.costs.retrainCostDetails.roles,
    coderStatus: state.status.coderStatus,
    dataAnalystStatus: state.status.dataAnalystStatus,
    managerStatus: state.status.managerStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setRetrainCostForRoleAttr: (obj) => dispatch(actions.setRetrainCostForRoleAttr(obj)),
    setRetrainCommonAttr: (obj) => dispatch(actions.setRetrainCostCommonAttr(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RetrainingCosts);
